import NextStepsBoard from '@/nextStep/components/NextStepsBoard'
import NextStepModal from '@/nextStep/modals/NextStepModal'
import { Box, useDisclosure } from '@chakra-ui/react'
import { MeetingStepNextStepsFragment } from '@rolebase/shared/model/meeting_step'
import React, { useContext } from 'react'
import { MeetingContext } from '../contexts/MeetingContext'

interface Props {
  // Accepted for symmetry with the other step contents, and deliberately
  // unused: the board reads the CIRCLE, never the step. It shows every
  // unarchived next step of the circle, across all meetings (D24), and the
  // step itself stores nothing (see MeetingStepDataNextSteps).
  step: MeetingStepNextStepsFragment
}

export default function MeetingStepContentNextSteps(_props: Props) {
  const { meeting, circle, isEnded } = useContext(MeetingContext)!
  const addModal = useDisclosure()

  if (!meeting || !circle) return null

  return (
    <Box my={5}>
      {/* Unlike the Tasks step, the board stays visible once the meeting has
          ended (G2-D17): a past report is read to see what was decided. What
          goes away are the actions — no ticking, no adding, no archiving. */}
      <NextStepsBoard
        circleId={circle.id}
        readOnly={isEnded}
        onAdd={addModal.onOpen}
      />

      {addModal.isOpen && (
        // A step added from the board carries no tension (G2-D19): threadId
        // stays empty, so it leaves no activity in any thread and shows no
        // tension badge. That absence is not the one D13 hides for privacy —
        // they look alike on screen and have nothing to do with each other.
        <NextStepModal
          scopeCircleId={circle.id}
          meetingId={meeting.id}
          isOpen
          onClose={addModal.onClose}
        />
      )}
    </Box>
  )
}
